import { render, staticRenderFns } from "./ViewOrderLeftContentPartial.vue?vue&type=template&id=0b8f653c&scoped=true&"
import script from "./ViewOrderLeftContentPartial.vue?vue&type=script&lang=js&"
export * from "./ViewOrderLeftContentPartial.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderLeftContentPartial.vue?vue&type=style&index=0&id=0b8f653c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f653c",
  null
  
)

export default component.exports